
import LazyHydrate from 'vue-lazy-hydration';

import Header from '@/components/header/Header.vue';
import Footer from '~/components/footer/Footer.vue';
import Highlight from '~/components/Highlight.vue';
import GoogleTagManager from '~/components/GoogleTagManager.vue';

export default {
  components: {
    GoogleTagManager,
    LazyHydrate,
    Highlight,
    Header,
    Footer,
  },
  head() {
    const script = [];
    const $cheq = this.$cheq(this.$paths.host);

    if ($cheq) {
      script.push({
        hid: 'cheq',
        ...$cheq.script,
      });
    }

    return {
      script,
    };
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    cheqNoScript() {
      const cheq = this.$cheq(this.$paths.host);
      return cheq ? cheq.noScript : '';
    },
    parkingDataWithSearch() {
      return {
        title: 'Valet Parking',
        review: {
          count: 5300,
          score: 8.7,
        },
        avgPricePerDay: '22$',
        filters: [{ 'valet-parking': true }],
        airportData: {
          id: 6,
          object: 'airport',
          iata_code: 'BRE',
          name: 'Bremen Airport',
          maintitle: 'Parkeren Bremen Airport',
          slug: 'parkeren-bremen-airport',
          devtitle: 'bremen-airport',
          header_image: null,
          from_price: 18,
          parking_count: 4,
          address: {
            street: 'Flughafenallee 20',
            zip_code: '28199',
            city: 'Bremen',
            latitude: 53.0475,
            longitude: 8.786667,
          },
          country: {
            id: 3,
            code: 'DE',
            name: 'Duitsland',
          },
          opening_times: {
            from: '0:00',
            till: '24:00',
          },
        },
      };
    },
    headerType() {
      return this.$route.path === '/static' || this.$route.path === '/demo' ? 'noHeader' : 'withSearch';
    },
  },
};
